export const ID = '3002a8b1-fb6b-4505-84b5-5af796f953a3';

export const NAME = 'StorageMart Facility List';

export const MAX_FEATURES = 3;
